export const LANGS = {
  en: {
    app: "Aarogya Sahayak",
    tagline: "by CODE4CARE",
    consult: "Doctor Consult",
    medicine: "Medicine Finder",
    records: "Health Records",
    symptom: "Symptom Checker",
    speak: "Voice Navigation",
    sos: "EMERGENCY",
    offline: "Offline mode - actions will sync when connected",
    online: "Online",
    disasterOn: "Emergency Mode ON",
    disasterOff: "Emergency Mode OFF",
    voiceHint: "Say: 'Doctor', 'Medicine', 'Records', or 'Symptoms'",
    lastUpdated: "Last updated",
    refresh: "Refresh",
    noInternet: "No connection - showing cached data",
    queuePlaced: "Request queued. You'll be contacted when online.",
    startCall: "Video Call",
    startAudio: "Audio Call",
    schedule: "Schedule Later",
    confirm: "Confirm",
    queued: "Pending Requests",
    none: "None",
    addVisit: "Add Visit",
    doctorName: "Doctor name",
    notes: "Notes",
    save: "Save",
    sync: "Sync",
    synced: "Synced",
    otpLogin: "Login with Phone + OTP",
    phone: "Phone",
    sendOtp: "Send OTP",
    enterOtp: "Enter OTP",
    verify: "Verify",
    logout: "Logout",
    fever: "Do you have fever?",
    cough: "Do you have cough?",
    yes: "Yes",
    no: "No",
    advice1: "Likely viral fever. Rest, hydrate, consult if >3 days.",
    advice2: "Monitor symptoms. Consult if worsening.",
    emergencyHelp: "Emergency Help",
    callHelpline: "Call Helpline",
    smsOnly: "Sending emergency SMS",
  },
  hi: {
    app: "आरोग्य सहायक",
    consult: "डॉक्टर से बात करें",
    medicine: "दवाई",
    records: "स्वास्थ्य रिकॉर्ड",
    symptom: "लक्षण जाँच",
    speak: "आवाज नेविगेशन",
    sos: "आपातकाल",
    offline: "ऑफलाइन मोड - कनेक्शन आने पर सिंक होगा",
    online: "ऑनलाइन",
    disasterOn: "आपदा मोड चालू",
    disasterOff: "आपदा मोड बंद",
    voiceHint: "कहें: 'डॉक्टर', 'दवाई', 'रिकॉर्ड', 'लक्षण'",
    lastUpdated: "आखिरी अपडेट",
    refresh: "रिफ्रेश",
    noInternet: "नेट नहीं - कैश्ड डेटा दिख रहा है",
    queuePlaced: "अनुरोध कतार में। ऑनलाइन आने पर कॉल करेंगे।",
    startCall: "वीडियो कॉल",
    startAudio: "ऑडियो कॉल",
    schedule: "बाद में शेड्यूल",
    confirm: "कन्फर्म",
    queued: "लंबित अनुरोध",
    none: "कोई नहीं",
    addVisit: "विज़िट जोड़ें",
    doctorName: "डॉक्टर नाम",
    notes: "नोट्स",
    save: "सेव",
    sync: "सिंक",
    synced: "सिंक हो गया",
    otpLogin: "फोन + OTP से लॉगिन",
    phone: "फ़ोन",
    sendOtp: "OTP भेजें",
    enterOtp: "OTP डालें",
    verify: "वेरिफाई",
    logout: "लॉगआउट",
    fever: "क्या बुखार है?",
    cough: "क्या खाँसी है?",
    yes: "हाँ",
    no: "नहीं",
    advice1: "वायरल बुखार लगता है। आराम करें, पानी पिएं।",
    advice2: "लक्षण देखते रहें। बिगड़े तो डॉक्टर से मिलें।",
    emergencyHelp: "आपातकाल सहायता",
    callHelpline: "हेल्पलाइन कॉल",
    smsOnly: "आपातकाल SMS भेज रहे हैं",
  },
  pa: {         
    app: "ਆਰੋਗਿਆ ਸਹਾਇਕ",
    consult: "ਡਾਕਟਰ ਨਾਲ ਸਲਾਹ ਕਰੋ",
    medicine: "ਦਵਾਈ ਲੱਭੋ",
    records: "ਸਿਹਤ ਰਿਕਾਰਡ",
    symptom: "ਲਛਣ ਜਾਂਚ",
    speak: "ਆਵਾਜ਼ ਨਾਲ ਨੇਵੀਗੇਸ਼ਨ",
    sos: "ਐਮਰਜੈਂਸੀ",
    offline: "ਆਫਲਾਈਨ ਮੋਡ - ਜੁੜਨ 'ਤੇ ਸਿੰਕ ਹੋਵੇਗਾ",
    online: "ਆਨਲਾਈਨ",
    disasterOn: "ਐਮਰਜੈਂਸੀ ਮੋਡ ਚਾਲੂ",
    disasterOff: "ਐਮਰਜੈਂਸੀ ਮੋਡ ਬੰਦ",
    voiceHint: "ਕਹੋ: 'ਡਾਕਟਰ', 'ਦਵਾਈ', 'ਰਿਕਾਰਡ', ਜਾਂ 'ਲਛਣ'",
    lastUpdated: "ਆਖਰੀ ਅੱਪਡੇਟ",
    refresh: "ਰੀਫਰੈਸ਼",
    noInternet: "ਕੋਈ ਕਨੈਕਸ਼ਨ ਨਹੀਂ - ਕੈਸ਼ਡ ਡਾਟਾ ਦਿਖਾਇਆ ਜਾ ਰਿਹਾ ਹੈ",
    queuePlaced: "ਰਿਕਵੇਸਟ ਕਤਾਰ ਵਿੱਚ। ਜੁੜਨ 'ਤੇ ਸੰਪਰਕ ਕੀਤਾ ਜਾਵੇਗਾ।",
    startCall: "ਵੀਡੀਓ ਕਾਲ",
    startAudio: "ਆਡੀਓ ਕਾਲ",
    schedule: "ਬਾਅਦ ਵਿੱਚ ਸ਼ਡਿਊਲ ਕਰੋ",
    confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
    queued: "ਬਕਾਇਆ ਬੇਨਤੀਆਂ",
    none: "ਕੋਈ ਨਹੀਂ",
    addVisit: "ਵਿਜ਼ਿਟ ਜੋੜੋ",
    doctorName: "ਡਾਕਟਰ ਦਾ ਨਾਂ",
    notes: "ਟਿੱਪਣੀਆਂ",
    save: "ਸੰਭਾਲੋ",
    sync: "ਸਿੰਕ ਕਰੋ",
    synced: "ਸਿੰਕ ਹੋ ਗਿਆ",
    otpLogin: "ਫੋਨ + ਓਟੀਪੀ ਨਾਲ ਲੌਗਇਨ ਕਰੋ",
    phone: "ਫ਼ੋਨ",
    sendOtp: "ਓਟੀਪੀ ਭੇਜੋ",
    enterOtp: "ਓਟੀਪੀ ਦਾਖਲ ਕਰੋ",
    verify: "ਤਸਦੀਕ ਕਰੋ",
    logout: "ਲੌਗਆਊਟ",
    fever: "ਕੀ ਤੁਹਾਨੂੰ ਬੁਖਾਰ ਹੈ?",
    cough: "ਕੀ ਤੁਹਾਨੂੰ ਖਾਂਸੀ ਹੈ?",
    yes: "ਹਾਂ",
    no: "ਨਹੀਂ",
    advice1: "ਸੰਭਵਤ: ਵਾਇਰਲ ਬੁਖਾਰ। ਆਰਾਮ ਕਰੋ, ਪਾਣੀ ਪੀਓ।",
    advice2: "ਲਛਣਾਂ 'ਤੇ ਨਿਗਰਾਨੀ ਕਰੋ। ਖਰਾਬ ਹੋਵੇ ਤਾਂ ਡਾਕਟਰ ਨੂੰ ਮਿਲੋ।",
    emergencyHelp: "ਐਮਰਜੈਂਸੀ ਸਹਾਇਤਾ",
    callHelpline: "ਹੈਲਪਲਾਈਨ ਕਾਲ ਕਰੋ",
    smsOnly: "ਐਮਰਜੈਂਸੀ SMS ਭੇਜ ਰਹੇ ਹਾਂ",
  },
};
